const updateVisibleEstimationModal = {
    namespaced: true,
    state: {
        isShowEstimationModal: false,
        isMeasurement: false,
        measurementId: null,
        isMeasurementInEdit: false,
        isProjectForm: false
    },
    mutations: {
        UPDATE_VISIBLE_ESTIMATION_MODAL(state, value) {
            state.isShowEstimationModal = value;
        },
        UPDATE_IS_MEASUREMENT_STATE(state, value) {
            state.isMeasurement = value;
        },
        UPDATE_MEASUREMENT_EDIT_ID(state, id) {
            state.measurementId = id;
        },
        UPDATE_MEASUREMENT_IN_EDIT(state, value) {
            state.isMeasurementInEdit = value;
        },
        UPDATE_IS_PROJECT_FORM(state, value) {
            state.isProjectForm = value;
        },
    },
    actions: {
        updateVisibleEstimationModal: function({ commit }, value) {
            commit("UPDATE_VISIBLE_ESTIMATION_MODAL", value);
        },
        updateIsMeasurementState({commit}, value) {
            commit("UPDATE_IS_MEASUREMENT_STATE", value);
        },
        updateMeasurementEditId({commit}, value) {
            commit("UPDATE_MEASUREMENT_EDIT_ID", value);
        },
        updateMeasurementInEdit({commit}, value) {
            commit("UPDATE_MEASUREMENT_IN_EDIT", value);
        },
        updateIsProjectForm({commit}, value) {
            commit("UPDATE_IS_PROJECT_FORM", value);
        }
    }
}

export default updateVisibleEstimationModal;